import config from 'garaje/config/environment';
import { MockUiHooks } from 'garaje/utils/mock-ui-hooks';

export function initialize() {
  if (config.mirageEnabled && !window._GarajeUiHookResponses) {
    window._GarajeUiHookResponses = new MockUiHooks();
  }
}

export default {
  // Initializers run before routes are instantiated, so this is guaranteed to
  // run before ApplicationRoute starts mirage and any scenarios populate the store.
  name: 'mock-ui-hooks',
  initialize,
};
